module.exports = __webpack_public_path__ + "media/components/Application/Influencers/Index/InfluencerExample/4_1-99ecb9cc35f79f37ec3cb9762077bd09.png";